'use client'

import React, { createContext, useCallback, useMemo, useState } from 'react'

import { TFunc } from '@/types'

interface IHeaderContext {
  isActive?: boolean
  onToggleMenu: TFunc
  onClose: (fn: TFunc) => () => void
}

export const HeaderContext = createContext({} as IHeaderContext)

export const HeaderProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isActive, setIsActive] = useState(false)

  const onToggleMenu = useCallback(() => {
    setIsActive(prev => !prev)
  }, [])

  const onClose = useCallback(
    (onClose: TFunc) => () => {
      onClose()
      setIsActive(false)
    },
    [],
  )

  const value = useMemo(
    () => ({ isActive, onToggleMenu, onClose }),
    [isActive, onToggleMenu, onClose],
  )

  return (
    <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
  )
}
